export default function SocialProof() {
  const businesses = [
    'Elite Auto Spa', 'Precision Detailing Co', 'Shine Masters', 
    'Crystal Clear Details', 'Premium Auto Care', 'Luxury Detail Studio',
    'Pro Finish Detailing', 'Diamond Auto Spa'
  ];

  return (
    <section className="bg-gray-50 py-8 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-center gap-12 flex-wrap">
          <div className="text-sm font-bold text-gray-500 tracking-wider uppercase">
            Trusted by 200+ Detailing Businesses
          </div>
          <div className="flex items-center gap-8 flex-wrap justify-center">
            {businesses.slice(0, 5).map((business, index) => (
              <div key={index} className="text-gray-400 font-semibold text-sm">
                {business}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
